import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { DataSource } from 'components/DataSource';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import { Uploader } from 'components/Uploader';
import useApi from 'hooks/useApi';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const GoldassetdetailAddPage = (props) => {
		const app = useApp();
	const api = useApi();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		loanaccountno: yup.string().required().label($t('loanaccountno')),
		itemdetail: yup.string().required().label($t('itemdetail')),
		qty: yup.number().required().label($t('qty')),
		itemtype: yup.string().required().label($t('itemtype')),
		purity: yup.number().required().label($t('purity')),
		grosswgt: yup.string().required().label($t('grosswgt')),
		stonewgt: yup.string().required().label($t('stonewgt')),
		netwgt: yup.string().required().label($t('netwgt')),
		currentrate_gm: yup.string().nullable().label($t('currentrateGm')),
		lendingrate_gm: yup.string().required().label($t('lendingrateGm')),
		netwgt_amount: yup.string().nullable().label($t('netwgtAmount')),
		remarks: yup.string().nullable().label($t('remarks')),
		asset_image: yup.string().nullable().label($t('assetImage'))
	});
	
	//form default values
	const formDefaultValues = {
		loanaccountno: '', 
		itemdetail: '', 
		qty: '', 
		itemtype: '', 
		purity: '', 
		grosswgt: '', 
		stonewgt: '', 
		netwgt: '', 
		currentrate_gm: "((0))", 
		lendingrate_gm: "0", 
		netwgt_amount: '', 
		remarks: '', 
		asset_image: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/goldassetdetail`);
		}
	}
	
	//auto fill other inputs on grosswgt change
	async function grosswgtAutoFill(e, formik, index) {
		formik.handleChange(e);
const grosswgt = parseFloat(e.target.value) || 0;
    const stonewgt = parseFloat(formik.values.stonewgt) || 0;
    formik.setFieldValue("grosswgt", e.target.value);
    const netwgt = grosswgt - stonewgt;
    formik.setFieldValue("netwgt", netwgt.toFixed(3));
	};
	
	//auto fill other inputs on stonewgt change
	async function stonewgtAutoFill(e, formik, index) {
		formik.handleChange(e);
const grosswgt = parseFloat(e.target.value) || 0;
    const stonewgt = parseFloat(formik.values.stonewgt) || 0;
    formik.setFieldValue("grosswgt", e.target.value);
    const netwgt = grosswgt - stonewgt;
    formik.setFieldValue("netwgt", netwgt.toFixed(3));
	};
	
	//auto fill other inputs on lendingrate_gm change
	async function lendingrateGmAutoFill(e, formik, index) {
		formik.handleChange(e);
		const val = e.target.value;
		const resp = await api.get(`components_data/goldassetdetail_lendingrate_gm_autofill?value=${val}`);
		const data = resp.data[0];
		if(data){
		}
	};
function grosswgtAutoFill(e, formik) {
    const grosswgt = parseFloat(e.target.value) || 0;
    const stonewgt = parseFloat(formik.values.stonewgt) || 0;
    formik.setFieldValue("grosswgt", e.target.value);
    const netwgt = grosswgt - stonewgt;
    formik.setFieldValue("netwgt", netwgt.toFixed(3));
}
function stonewgtAutoFill(e, formik) {
    const stonewgt = parseFloat(e.target.value) || 0;
    const grosswgt = parseFloat(formik.values.grosswgt) || 0;
    formik.setFieldValue("stonewgt", e.target.value);
    const netwgt = grosswgt - stonewgt;
    formik.setFieldValue("netwgt", netwgt.toFixed(3));
}
function lendingrateGmAutoFill(e, formik) {
    const lendingRate = parseFloat(e.target.value) || 0;
    const netwgt = parseFloat(formik.values.netwgt) || 0;
    formik.setFieldValue("LendingRate_gm", e.target.value);
    const amt = lendingRate * netwgt;
    formik.setFieldValue(
    "NetWgt_Amount",
    amt.toFixed(2)
    );
}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="GoldassetdetailAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewGoldassetdetail')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loanaccountno')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loanaccountno"  onChange={formik.handleChange}  value={formik.values.loanaccountno}   label={$t('loanaccountno')} type="text" placeholder={$t('enterLoanaccountno')}     disabled   className={inputClassName(formik?.errors?.loanaccountno)} />
                                                <DataSource   apiPath="components_data/loanaccountno_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <datalist id="loanaccountno_list">
                                                    { response.map((option, index)=> <option key={index} value={option.value}>{option.label}</option>)}
                                                    </datalist>
                                                    </>
                                                    }
                                                </DataSource>
                                                <ErrorMessage name="loanaccountno" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('itemdetail')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="itemdetail"  onChange={formik.handleChange}  value={formik.values.itemdetail}   label={$t('itemdetail')} type="text" placeholder={$t('enterItemdetail')}        className={inputClassName(formik?.errors?.itemdetail)} />
                                                <ErrorMessage name="itemdetail" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('qty')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="qty"  onChange={formik.handleChange}  value={formik.values.qty}   label={$t('qty')} type="number" placeholder={$t('enterQty')}  min={0}  step="any"    className={inputClassName(formik?.errors?.qty)} />
                                                <ErrorMessage name="qty" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('itemtype')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="itemtype"  onChange={formik.handleChange}  value={formik.values.itemtype}   label={$t('itemtype')} type="text" placeholder={$t('enterItemtype')}        className={inputClassName(formik?.errors?.itemtype)} />
                                                <ErrorMessage name="itemtype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('purity')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="purity"  onChange={formik.handleChange}  value={formik.values.purity}   label={$t('purity')} type="number" placeholder={$t('enterPurity')}  min={0}  step="any"    className={inputClassName(formik?.errors?.purity)} />
                                                <ErrorMessage name="purity" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('grosswgt')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="grosswgt"  onChange={(e)=>grosswgtAutoFill(e, formik)}  value={formik.values.grosswgt}   label={$t('grosswgt')} type="text" placeholder={$t('enterGrosswgt')}        className={inputClassName(formik?.errors?.grosswgt)} />
                                                <ErrorMessage name="grosswgt" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('stonewgt')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="stonewgt"  onChange={(e)=>stonewgtAutoFill(e, formik)}  value={formik.values.stonewgt}   label={$t('stonewgt')} type="text" placeholder={$t('enterStonewgt')}        className={inputClassName(formik?.errors?.stonewgt)} />
                                                <ErrorMessage name="stonewgt" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('netwgt')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="netwgt"  onChange={formik.handleChange}  value={formik.values.netwgt}   label={$t('netwgt')} type="text" placeholder={$t('enterNetwgt')}        className={inputClassName(formik?.errors?.netwgt)} />
                                                <ErrorMessage name="netwgt" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('currentrateGm')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="currentrate_gm"  onChange={formik.handleChange}  value={formik.values.currentrate_gm}   label={$t('currentrateGm')} type="text" placeholder={$t('enterCurrentrateGm')}        className={inputClassName(formik?.errors?.currentrate_gm)} />
                                                <ErrorMessage name="currentrate_gm" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('lendingrateGm')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="lendingrate_gm"  onChange={(e)=>lendingrateGmAutoFill(e, formik)}  value={formik.values.lendingrate_gm}   label={$t('lendingrateGm')} type="text" placeholder={$t('enterLendingrateGm')}        className={inputClassName(formik?.errors?.lendingrate_gm)} />
                                                <ErrorMessage name="lendingrate_gm" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('netwgtAmount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="netwgt_amount"  onChange={formik.handleChange}  value={formik.values.netwgt_amount}   label={$t('netwgtAmount')} type="text" placeholder={$t('enterNetwgtAmount')}        className={inputClassName(formik?.errors?.netwgt_amount)} />
                                                <ErrorMessage name="netwgt_amount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('remarks')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="remarks"  onChange={formik.handleChange}  value={formik.values.remarks}   label={$t('remarks')} type="text" placeholder={$t('enterRemarks')}        className={inputClassName(formik?.errors?.remarks)} />
                                                <ErrorMessage name="remarks" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('assetImage')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.asset_image)}>
                                                    <Uploader name="asset_image" showUploadedFiles value={formik.values.asset_image} uploadPath="fileuploader/upload/asset_image" onChange={(paths) => formik.setFieldValue('asset_image', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label={$t('chooseFilesOrDropFilesHere')} onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="asset_image" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
GoldassetdetailAddPage.defaultProps = {
	primaryKey: 'assetid',
	pageName: 'goldassetdetail',
	apiPath: 'goldassetdetail/add',
	routeName: 'goldassetdetailadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default GoldassetdetailAddPage;
